import isMap from './isMap';
export default function get(key, x) {
  return isMap(x) ? x.get(key) : x[key];
}


//////////////////
// WEBPACK FOOTER
// ./~/redux-blueprint/~/redux-actions/es/utils/get.js
// module id = 689
// module chunks = 1